import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

@Injectable()
export class OrderDetailsNavigationService {
  constructor(private router: Router) {}

  back(): void {
    const hasHistory = window.history.state.navigationId > 1;
    if (hasHistory) {
      window.history.back();
    } else {
      this.router.navigate(['/orders']);
    }
  }
}
